import Vue from "vue";
import VueTimeline from "@growthbunker/vuetimeline";

Vue.use(VueTimeline);